<template>
  <v-tooltip bottom color="font" :key="key" :disabled="!tooltip">
    <template #activator="{ on }">
      <span v-on="on" :class="$attrs.classes">
        <slot v-bind="{ ...$props, ...$attrs }">
          <v-btn
            :[buttonSize]="true"
            icon
            v-on="computedListeners"
            :disabled="disabled"
            :loading="isLoading"
            :class="{ divider: $attrs.hasDivider }"
          >
            <v-icon :color="computedColor" :class="{ background: isActive }" :size="fontSize">
              {{ icon }}
            </v-icon>
          </v-btn>
        </slot>
      </span>
    </template>
    {{ tooltip }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'TableButton',
  props: {
    hasState: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    fontSize: {
      type: String,
      default: '24px',
    },
    color: {
      type: String,
      default: 'rgba(0,0,0,0.7)',
    },
    customColor: {
      type: String,
      default: '',
    },
    buttonSize: {
      type: String,
      default: 'default',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    key() {
      return `${this.name}-tooltip`;
    },
    computedColor() {
      if (this.disabled) {
        return;
      }
      if (this.customColor) {
        return this.customColor;
      }
      return this.isActive ? 'link' : this.color;
    },
    computedListeners() {
      return {
        ...this.$listeners,
        click: () => {
          this.$emit(this.name);
          this.$emit('click');
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  background-color: #e8f0fe !important;
  color: map-get($colors, 'link') !important;
  border-radius: 2px;
}
.divider {
  position: relative;
  margin-right: 18px;
  &::after {
    content: '';
    position: absolute;
    @include border(right);
    height: 100%;
    right: -9px;
    top: 0;
  }
}
</style>
